// extracted by mini-css-extract-plugin
export default {"quickstats":"Quickstats_quickstats__x+oL2","quickstats_inner":"Quickstats_quickstats_inner__v6NFF","wrapper":"Quickstats_wrapper__RgxBr"};